<!-- eslint-disable -->
<template>
    <div class="box dashboard-box" v-show="confirmations && confirmations.length">
        <div class="header">Подтверждения</div>
        <div class="columns is-multiline is-mobile">
            <div class="column is-12-desktop is-12-tablet is-12-mobile confirmations">
                <transition-group name="confirmations">
                    <confirmation v-for="confirmation, index in confirmations"
                                  :confirmation="confirmation"
                                  :index="index"
                                  :key="confirmation.id"
                                  @remove="remove(index)"
                    ></confirmation>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import ConfirmationApi from "../../../api/confirmation"
    import Confirmation from './Confirmation.vue'

    export default {
        data () {
            return {
                confirmations: []
            };
        },
        mounted () {
            this.fetchData();
        },
        methods: {
            fetchData () {
                ConfirmationApi.list({})
                    .then(confirmations => {
                        this.confirmations = confirmations;
                    })
                    .catch(err => {
                        this.$toasted.error(this.$root.$t('errors.getting_agreements'));
                    })
            },
            remove (index) {
                this.confirmations.splice(index, 1);
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            })
        },
        components: {
            Confirmation
        }
    }
</script>

<style>
    .confirmations-leave-active {
        transition: all 0.3s;
    }
    .confirmations-leave-to {
        opacity: 0;
        transform: translateX(100px);
    }
</style>
